export default [
    {
        path: '/team',
        name: 'team',
        component: () => import("../views/team/index.vue"),
        redirect: '/team/database',
        children: [
            {
                path: '/team/database',
                name: 'database',
                component: () => import("../views/team/database.vue"),
                meta: {
                    scrollToTop: true
                }
            },
            {
                path: '/team/schedule',
                name: 'schedule',
                component: () => import("../views/team/schedule.vue")
            },
            {
                path: '/team/lineup',
                name: 'lineup',
                component: () => import("../views/team/lineup.vue"),
                meta: {
                    scrollToTop: true
                }
            },
            {
                path: '/team/data',
                name: 'data',
                component: () => import("../views/team/data.vue"),
                meta: {
                    scrollToTop: true
                }
            },
            {
                path: '/team/dynamic',
                name: 'dynamic',
                component: () => import("../views/team/dynamic.vue"),
                meta: {
                    scrollToTop: true
                }
            }
        ]
    }
]
